import { Organization } from "@gettactic/api";
import { isProduction } from "../isProduction";
import { getOrganizationUrlFromSlug } from "./getOrganizationUrlFromSlug";

export const getOrganizationUrl = (
  organization: Organization,
  url?: string
) => {
  return getOrganizationUrlFromSlug(organization.slug || "", url);
};
